class AccountingSftpGbat10Controller extends AbstractSftpController
	@register()
	@inject 'translate',
		'IntegrationService'
		'Shops'
		'ShopRepository'
		'VatRates'
		'BACKEND_TRANSACTION_CARD_TYPE'
		'TenderTypes'
		'ConfigurationService'

	integrationId: 'accountingSftpGbat10'

	initialize: ->
		super()

		@$scope.paymentAccounts = @IntegrationService.getMappableSftpAccounts()
		@$scope.cardTypes = @BACKEND_TRANSACTION_CARD_TYPE
		@$scope.tenderTypes = @TenderTypes.data
		@$scope.isSellOnCommsionEnabled = @ConfigurationService.isEnabled 'POS.Setting.SellOnCommission.Enabled'

		@$scope.defaultConfig =
			payments:
				card_payments:
					account: '1920'
					code: '1'
				cash_payments:
					account: '1901'
					code: '1'
				default:
					account: '1579'
					code: '1'
			vat_rates:
				0:
					account: '2759'
					code: '0'
				12:
					account: '2754'
					code: '4'
				15:
					account: '2753'
					code: '2'
				25:
					account: '2751'
					code: '1'
			deviation:
				account: '1901'
				code: '1'
			report_number: 1

		@$scope.maxAccountLength = 4
		@$scope.maxVatCodeLength = 5
		@defaultEntitiesDataList = [{id: 'unspecified', name: 'unspecified'}]
		@$scope.vatRates = @VatRates.data.concat(@defaultEntitiesDataList)
		@$scope.shops = @Shops.data.concat(@defaultEntitiesDataList)
		@$scope.tenderTypes = @$scope.tenderTypes.concat(@defaultEntitiesDataList)

		if !@$scope.hasErrorData
			@setUpDefaultConfigurationValues()

	setUpDefaultConfigurationValues: ->
		@ensureObjectsInConfiguration(@$scope.configuration, ['vat_rates', 'payments', 'downpayment'])

		angular.forEach @$scope.vatRates, (vatRate) =>
			vatRateValue = parseInt(vatRate.percentage * 100)

			if !@$scope.configuration.vat_rates[vatRate.id] and @$scope.defaultConfig.vat_rates[vatRateValue]
				@$scope.configuration.vat_rates[vatRate.id] = angular.copy @$scope.defaultConfig.vat_rates[vatRateValue]

		angular.forEach @$scope.paymentAccounts, (paymentAccount) =>
			if !@$scope.configuration.payments[paymentAccount.key]
				@$scope.configuration.payments[paymentAccount.key] = @$scope.defaultConfig.payments[paymentAccount.key] ?
					angular.copy @$scope.defaultConfig.payments.default

		if !@$scope.configuration.deviation
			@$scope.configuration.deviation = angular.copy @$scope.defaultConfig.deviation

		if !@$scope.configuration.report_number
			@$scope.configuration.report_number = angular.copy @$scope.defaultConfig.report_number

	getPercentageLabelText: (value) ->
		if value?
			return '(' + (value * 100).toFixed(2) + ' %)'

		return value

	runIntegration: (timestampFrom, timestampTo, timeZone, splitByDays) ->
		@$scope.saving = true

		requestBody =
			from: timestampFrom
			to: timestampTo
			time_zone: timeZone
			split_by_days: splitByDays

		@IntegrationRepository
			.run @integrationId, requestBody
			.then =>
				@ToastService.add(
					@translate(@headerText),
					@translate('general.integration'),
					@translate('general.operation.success'),
					'success'
				)
			.catch (response) =>
				@ToastService.showErrors response, @translate(@headerText)
			.finally =>
				@$scope.saving = false

	afterDisconnect: ->
		@$scope.configuration = {}
